import { StatusCodes } from "http-status-codes";
import { AmazonianInformation } from "lib/models/oui-models";
import * as cache from "memory-cache";

import { Catalinav2BaseService } from "./catalinav2-base-service";

const USER_INFORMATION_CACHE_KEY = "USER_INFORMATION";
const CACHE_EXPIRATION_IN_MILLISECONDS = 15 * 60 * 1000; // 15 minutes

export class UserInformation extends Catalinav2BaseService {
  /**
   * Singleton instance with the current user permissions.
   */
  public static current = new UserInformation();

  public async getUserInformation(): Promise<AmazonianInformation> {
    const userInfo = cache.get(USER_INFORMATION_CACHE_KEY) as AmazonianInformation;

    if (!userInfo) {
      // userInfo have expired
      await this.refreshUserInformation();
      return cache.get(USER_INFORMATION_CACHE_KEY) as AmazonianInformation;
    }

    return userInfo;
  }

  public async refreshUserInformation() {
    const response = await this.fetch("/user-info");
    if (response.status !== StatusCodes.OK) {
      throw new Error("An error occurred getting the user information.");
    }
    const jsonResponse = await response.json();
    const value = jsonResponse;
    cache.put(USER_INFORMATION_CACHE_KEY, value, CACHE_EXPIRATION_IN_MILLISECONDS);
  }

  public getCachedAmazonianInformation() {
    return cache.get(USER_INFORMATION_CACHE_KEY) as AmazonianInformation;
  }
}
